import gql from 'graphql-tag';

export const FETCH_INVITE_INFO = gql`
  query getInvite($token: String!) {
    invite(token: $token) {
      email
      inviteType
      organization {
        address
        businessName
        completedDocumentsCount
        name
        plan {
          active
          amount
          apiAccess
          currency
          interval
          name
          nickname
          organizationMembersLimit
          organizationsLimit
          planType
          templatesLimit
          uuid
        }
        users {
          nodes{
            uuid
          }
        }
        uuid
      }
      recipientName
      upgradeToPlan {
        amount
        apiAccess
        currency
        interval
        name
        nickname
        planType
        uuid
      }
      uuid
    }
  }
`;

export default {
  FETCH_INVITE_INFO,
};
